/* מצב הממשק: התקופה המוצגת, הודעות, ומצב מסך התזרים. לא נשמר בשרת */
import { useSyncExternalStore } from 'react';
import { S, notify, subscribe } from '../domain/state.js';
import { curKey } from '../domain/periods.js';
import { syncThemeColor } from '../lib/install.js';
import { txfDefault } from '../domain/txFilter.js';

const ls = {
  get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : v; } catch { return d; } },
  set(k, v) { try { localStorage.setItem(k, v); } catch { /* מצב פרטי */ } },
};
export { ls };

export const UI = {
  viewKey: curKey(),
  toast: null,
  loading: 0,
  flowPer: parseInt(ls.get('flow_per', '1'), 10) || 1, // כמו בבית: עד סוף התקופה
  flowStress: false,
  flowSim: {}, // מזהה חיוב קבוע ← יום חדש (סימולציה)
  dark: ls.get('dark', '') === '1',
  // סינון מסך הפעולות. נשמר כשעוברים מסך. "בלי חיובים קבועים" נשמר גם אחרי רענון
  txf: { ...txfDefault(), hideFixed: ls.get('hide_fixed', '') === '1' },
};

export function setTxf(patch) {
  const txf = { ...UI.txf, ...patch };
  if ('hideFixed' in patch) ls.set('hide_fixed', txf.hideFixed ? '1' : '');
  setUi({ txf });
}

export function setUi(patch) {
  Object.assign(UI, patch);
  notify();
}

const getVer = () => S.ver;
/** מנוי לכל שינוי (נתונים או ממשק) */
export function useApp() {
  useSyncExternalStore(subscribe, getVer, getVer);
  return S;
}

let toastTimer = null;
export function toast(msg) {
  msg = String(msg == null ? '' : msg);
  setUi({ toast: { msg, id: Date.now() } });
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => setUi({ toast: null }), Math.min(7000, 2200 + msg.length * 35));
}

export function setLoading(p) {
  setUi({ loading: p });
  if (p >= 100) setTimeout(() => setUi({ loading: 0 }), 400);
}

export function setDark(on) {
  document.documentElement.toggleAttribute('data-dark', on);
  syncThemeColor(on);
  ls.set('dark', on ? '1' : '');
  setUi({ dark: on });
}
